const partsAt = (value: Date, zone: string) => {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(value);
  const get = (name: string) => parts.find(p => p.type === name)?.value;
  return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}`;
};
export const utcToCampusInput = (utc: string, zone: string) => partsAt(new Date(utc), zone);

// Resolve the institutional zone, never the browser's local time zone. Test both
// sides of DST transitions; reject ambiguous/nonexistent wall-clock times.
export function campusInputToUTC(local: string, zone: string): string {
  if (!/^\d{4}-\d\d-\d\dT\d\d:\d\d$/.test(local)) throw new Error('Enter a complete lecture date and time.');
  const naive = Date.parse(local + ':00Z');
  if (!Number.isFinite(naive) || new Date(naive).toISOString().slice(0,16) !== local) throw new Error('Invalid lecture time.');
  const candidates = new Set<number>();
  for (const delta of [-36, -12, 0, 12, 36]) {
    const probe = naive + delta * 3600000;
    const offset = Date.parse(partsAt(new Date(probe), zone) + ':00Z') - probe;
    const candidate = naive - offset;
    if (partsAt(new Date(candidate), zone) === local) candidates.add(candidate);
  }
  if (candidates.size !== 1) throw new Error('This local time is ambiguous or unavailable during a clock change. Choose another time.');
  return new Date(Array.from(candidates)[0]).toISOString();
}
